import { useEffect, useState } from 'react';
import { useAppSelector } from 'app/hooks';

import { UserNoPassword } from 'types';
import { Role } from 'utils/userPermissions';

import { useIsAdmin } from 'features/auth/hooks/useIsAdmin';
import { useUsers } from '../api/getUsers';
import { useUserPermissionSettings } from '../api/getUserPermissionSettings';

export const usePermissionedUsers = (
  snapshotId: number,
  analyzerId: number
) => {
  const { user } = useAppSelector((state) => state.auth);
  const [permissionedUsers, setPermissionedUsers] = useState<UserNoPassword[]>(
    []
  );
  const isAdmin = useIsAdmin();
  const { data: users } = useUsers({});
  const { data: permissionSettings } = useUserPermissionSettings({});

  useEffect(() => {
    if (isAdmin && users) {
      let usersWithPermissions: UserNoPassword[] = [];
      const { snapshot_compartmentalization } = permissionSettings || {};
      usersWithPermissions = users.filter((userToAdd) => {
        if (userToAdd.role === Role.ADMIN) return true;
        if (userToAdd.role === Role.VIEWER) return false;
        if (snapshot_compartmentalization) {
          return userToAdd.user_snapshot_permission.some(
            (permission) => permission.snapshot_id === snapshotId
          );
        } else {
          return userToAdd.user_analyzer_permission.some(
            (permission) => permission.analyzer_id === analyzerId
          );
        }
      });
      if (user?.role === Role.SUPER_USER) usersWithPermissions.push(user);
      setPermissionedUsers(usersWithPermissions);
    } else {
      if (user) setPermissionedUsers([user]);
    }
  }, [users, permissionSettings, analyzerId, isAdmin, snapshotId, user]);

  return permissionedUsers;
};
